<template>
	<article class="new-question">
		<div class="site-wrapper rythm-v">
			<header>
				<h1>Nouvelle question</h1>
			</header>

			<section class="section--new-question rythm-v">
				<header>
					<h2>Étape 2 – Détails</h2>
				</header>

				<div class="card shadow rythm-v">
					<form @submit.prevent="updateQuestionData()">
						<section>
							<header>
								<h3>Détails de la question</h3>
							</header>

							<p class="label">Type de la question posée :</p>
							<div class="input-group--inline">
								<label>
									<input
										type="radio"
										name="questionType"
										id="questionType[general]"
										value="general"
										v-model="details.questionType"
										required
									/>
									<span class="caption">Question Générale</span>
								</label>
								<label>
									<input
										type="radio"
										name="questionType"
										id="questionType[patient]"
										value="patient"
										v-model="details.questionType"
										required
									/>
									<span class="caption">Question relative à un patient</span>
								</label>
							</div>

							<div class="input-group">
								<label for="questionTitle">Titre de la question :</label>
								<input type="text" name="questionTitle" id="questionTitle" v-model="details.questionTitle" required />
							</div>

							<div class="input-group">
								<label for="questionDetails">Question détaillée :</label>
								<textarea
									name="questionDetails"
									id="questionDetails"
									cols="30"
									rows="5"
									v-model="details.questionDetails"
								></textarea>
							</div>
						</section>

						<section>
							<div class="input-group--inline-controls">
								<button class="button--primary" type="submit">
									<span class="caption">Enregistrer</span>
									<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
										<path
											fill="currentColor"
											fill-rule="evenodd"
											d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893C6.90237 0.683418 6.90237 1.31658 7.29289 1.70711L12.5858 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H12.5858L7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70711 0.292893Z"
											clip-rule="evenodd"
										/>
									</svg>
								</button>
							</div>
						</section>
					</form>
				</div>
			</section>
		</div>
	</article>
</template>

<style lang="scss">
@import "src/scss/question.scss";
</style>

<script>
import buttonResetQuestion from "@/components/buttonResetQuestion";

export default {
	name: "QuestionEditDetails",

	components: {
		buttonResetQuestion
	},

	props: ["questionID"],

	data: function() {
		return {
			isDraft: false,

			details: {
				questionTitle: "",
				questionDetails: "",
				questionType: ""
			}
		};
	},

	methods: {
		// Update the draft then insert a new question in database
		updateQuestionData: function() {
			let payload = {
				questionID: this.questionID,
				dataFragment: {details: this.details}
			};
			this.$store
				.dispatch("SAVE_QUESTION_DRAFT", payload)
				.then(() => {
					// TODO: Now it's time to insert some stuff in database
					// NOTE: Afterwards the draft will be deleted
					this.$store
						.dispatch("SAVE_QUESTION")
						.then(questionID => {
							console.log("this.questionID", questionID);
							this.$router.push(`/edit-question-documents/${questionID}`);
						})
						.catch(error => {
							console.error("SAVE_QUESTION error");
						});
				})
				.catch(error => {
					console.error("SAVE_QUESTION_DRAFT error");
				});
		}
	},

	mounted() {
		// Go back if no data
		if (!this.$store.state.questionDraft) return this.$router.push(`/edit-question-themes/0`);

		// Check if there is a local draft
		if (!parseInt(this.questionID)) {
			let questionData = this.$store.state.questionDraft;

			if (null !== questionData && questionData.details) {
				this.details = questionData.details;
				this.isDraft = true;
			}
		}

		// TODO: Else, with a questionID, fetch questionData from the API
	}
};
</script>
